module.exports = __webpack_public_path__ + "img/xss_search-1.be1e6e94.jpeg";